import {ContextMenuPolyfillService} from './ContextMenuPolyfill';


const angular = require('angular');

export const reactUtilsModule = angular
  .module('app.core-utilities.react-utils', [])
  .service(ContextMenuPolyfillService.SERVICE_NAME, ContextMenuPolyfillService)
;



// WEBPACK FOOTER //
// ./src/js/core-utilities/react-utils/module.js